import api from '@/services/api/api'

class ArtworkTypes {
  getAllArtworkTypes () {
    return api.get('artwork-type').then(result => {
      return result.data
    })
  }

  saveArtworkType (artworkType) {
    return api.post('artwork-type', artworkType)
  }

  removeArtworkType (artworkType) {
    return api.delete('artwork-type/' + artworkType.id)
  }
}

export default new ArtworkTypes()



// WEBPACK FOOTER //
// ./src/services/codebooks/ArtworkTypesService.js